import React, { useState } from "react";
import { Img, Text } from "components";
import { useTranslation } from "react-i18next";
import * as CUSTOM from "../../../../utils/helper/custom";
import { useSelector } from "react-redux";
import YourDetails from "./yourDetails";
import { TryRounded } from "@mui/icons-material";
import { getOrderData } from "../../../../redux/reducers/orderData";

const Account = () => {
  const { t } = useTranslation();
  const orderData = useSelector(getOrderData);
  const [isYourDetails, setIsYourDetails] = useState(false);

  return (
    <>
      <div className="relative flex flex-col w-full">
        {/* Account Summary — redesigned to match Cart's Account summary block */}
        <div className="flex flex-col gap-4 items-center justify-start w-full mb-[18px]">
          <div className="flex flex-row md:gap-5 items-center justify-start w-full">
            <div className="flex flex-col gap-1 items-start justify-start flex-1">
              {/* Title — Cart uses Unbounded font + larger size */}
              <Text
                className="
                  relative z-10 break-words
                  text-[#1A1A1A] font-['Unbounded'] font-medium
                  text-[24px] leading-[32px]
                  sm:text-[20px] sm:leading-[28px]
                "
              >
                {/* {t("account")} */}
                Account Information
              </Text>
              <div className="flex gap-1 flex-row items-center">
                <Text className="text-black-900 text-sm nunitoregular">
                  {CUSTOM.getLoginDataByKey("fullname")}
                </Text>
                <Img
                  className="h-6 w-6"
                  src="/images/img_checkmark_teal_400.svg"
                  alt="checkmark"
                />
              </div>
            </div>
          </div>

          {/* Your Details card — Cart style: light_blue-50 bg, Inter font */}
          <div className="common-pointer bg-light_blue-50 flex flex-col items-center justify-start py-3 px-6 xs:px-3 w-full">
            <div className="flex flex-row items-center justify-between w-full">
              <div className="flex flex-col gap-1 items-start justify-start">
                <Text
                  className="text-base text-black-900 font-['Unbounded']"
                  size="txtnunitoMedium16"
                >
                  {t("yourDetails")}
                </Text>
                <Text className="text-black-900 text-sm font-['Inter']">
                  {orderData?.userDetails?.first_name}{" "}
                  {orderData?.userDetails?.last_name} | +966{" "}
                  {orderData?.userDetails?.mobile_no} |{" "}
                  {orderData?.userDetails?.email}
                </Text>
              </div>
              <Img
                className="h-6 w-6 rtl:rotate-180"
                src="/images/img_arrowright.svg"
                alt="arrowright"
                onClick={() => {
                  // NOTE: original logic used TryRounded (MUI icon) as truthy value — preserved as-is
                  setIsYourDetails(TryRounded);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {isYourDetails ? (
        <YourDetails setIsYourDetails={setIsYourDetails} />
      ) : null}
    </>
  );
};

export default Account;
